import React, { useEffect, useState, useRef } from 'react';
import Navbar from '../components/Navbar';
import './TeachersTeam.css';

const TeachersTeam = () => {
  const [activeSubject, setActiveSubject] = useState('mathematics');
  const [isChanging, setIsChanging] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const subjectRef = useRef(null);
  const facultySectionRef = useRef(null);
  const [bgLoaded, setBgLoaded] = useState(false);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  useEffect(() => {
    const img = new window.Image();
    img.src = '/050A1647.webp';
    img.onload = () => setBgLoaded(true);
  }, []);
  
  // Handle subject change with animation
  const handleSubjectChange = (subject) => {
    if (subject === activeSubject) return;
    setHasInteracted(true);
    setIsChanging(true);
    setTimeout(() => {
      setActiveSubject(subject);
      setIsChanging(false);
    }, 300); // Match this with the CSS transition time
  };
  
  // Check URL hash on component mount
  useEffect(() => {
    // If there's a hash in the URL, scroll to the faculty section first
    if (window.location.hash === '#faculty' && facultySectionRef.current) {
      setTimeout(() => {
        const yOffset = -80; // Adjust this value as needed
        const element = facultySectionRef.current;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }, 500); // Small delay to ensure the page is fully loaded
    }
  }, []);
  
  // Scroll to subject details when a subject is selected by user
  useEffect(() => {
    if (hasInteracted && activeSubject && subjectRef.current) {
      const yOffset = -100; // Adjust this value as needed for proper scrolling position
      const element = subjectRef.current;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  }, [activeSubject, hasInteracted]);

  const faculties = {
    mathematics: [
      {
        name: "Prof. Vanshvardhan Biyani",
        degree: "B.E. - Information Technology",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Kaushik Tiwari",
        degree: "B.E. - Computer Engineering",
        experience: "20 YRS",
        achievements: ""
      },
      {
        name: "Prof. Bhavesh Maniar",
        degree: "B.Sc., B.Ed., Author For Chetna Publication",
        experience: "31 YRS",
        achievements: ""
      },
      {
        name: "Prof. Sneha Menon",
        degree: "B.E. - Electronics",
        experience: "16 YRS",
        achievements: ""
      },
      {
        name: "Prof. Rahul Dsilva",
        degree: "B.E. - Information Technology",
        experience: "8 YRS",
        achievements: ""
      },
      {
        name: "Prof. Varun Singh",
        degree: "MSc (mathematics) B.E.",
        experience: "16 YRS",
        achievements: ""
      },
      {
        name: "Prof. Umesh Mukati",
        degree: "B. Tech. - Mechanical Engineering",
        experience: "8 YRS",
        achievements: ""
      },
      {
        name: "Prof. Hiren Patel",
        degree: "B.Sc. - Maths, B.Ed.",
        experience: "17 YRS",
        achievements: ""
      },
      {
        name: "Prof. Pankaj Agarwal",
        degree: "B.E. EXTC",
        experience: "8 YRS",
        achievements: ""
      },
      {
        name: "Prof. Nishant Kadam",
        degree: "MCom",
        experience: "3 YRS",
        achievements: ""
      },
      {
        name: "Prof. Rahul Yadav",
        degree: "",
        experience: "",
        achievements: ""
      },
      {
        name: "Prof. Dileep Shukla",
        degree: "B.E. - Civil , B.Ed",
        experience: "9 YRS",
        achievements: ""
      }
    ],
    science: [
      {
        name: "Prof. Yashvardhan Biyani",
        degree: "B.Tech. – Petroleum Engineering",
        experience: "13 YRS",
        achievements: ""
      },
      {
        name: "Prof. Vanshvardhan Biyani",
        degree: "B.E. – Information Technology",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Nitin Tiwari",
        degree: "B.Sc.",
        experience: "15 YRS",
        achievements: ""
      },
      {
        name: "Prof. Vijay Dubey",
        degree: "B.E. – Electronics",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Anwar Shaikh",
        degree: "B.Sc – Information Technology, B.Ed.",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Sunil Gupta",
        degree: "B.E. – Mechanical Engineering",
        experience: "12 YRS",
        achievements: ""
      },
      {
        name: "Prof. Arpit Shah",
        degree: "B.E. – Electronics",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Nidhi Biyani",
        degree: "B. Tech. – Chemical Engineering",
        experience: "8 YRS",
        achievements: ""
      },
      {
        name: "Prof. Umesh Mukati",
        degree: "B. Tech. – Mechanical Engineering",
        experience: "8 YRS",
        achievements: ""
      },
      {
        name: "Prof. Satish Kanojia",
        degree: "M.Sc., B.Ed. , M.A.- Education",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Shivam Pandey",
        degree: "M.Sc",
        experience: "6 YRS",
        achievements: ""
      },
      {
        name: "Prof. Kavita Pal",
        degree: "M.Sc. Organic Chem, B.Ed.",
        experience: "7 YRS",
        achievements: ""
      },
      {
        name: "Prof. Avni Mishra",
        degree: "M.Sc. Chemistry",
        experience: "6 YRS",
        achievements: ""
      },
      {
        name: "Prof. Urmila Panchal",
        degree: "M. Sc. – Organic Chemistry, B. Ed.",
        experience: "18 YRS",
        achievements: ""
      },
      {
        name: "Prof. Utsav Jain",
        degree: "B.Sc. B.Ed.",
        experience: "12 YRS",
        achievements: ""
      },
      {
        name: "Prof. Shilpa Kulkarni",
        degree: "M.Sc. B.Ed.",
        experience: "12 YRS",
        achievements: ""
      },
      {
        name: "Dr. Kaushal Shah",
        degree: "BHMS (Mumbai), CCH, CSD",
        experience: "16 YRS",
        achievements: ""
      },
      {
        name: "Prof. Pooja Baiju",
        degree: "M.Phil. – Genetics, M.Tech. – Biotech",
        experience: "16 YRS",
        achievements: ""
      },
      {
        name: "Prof. Sargam Pandit",
        degree: "B. Sc. Biotechnology",
        experience: "5 YRS",
        achievements: ""
      },
      {
        name: "Prof. Nafisa Raza",
        degree: "MSc. Zoology B.ED.",
        experience: "9 YRS",
        achievements: ""
      },
      {
        name: "Prof. Reena Singh",
        degree: "MSc., B.ED.",
        experience: "18 YRS",
        achievements: ""
      },
      {
        name: "Prof. Nitin Parmar",
        degree: "B.Ed.",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Dr. Khushboo Biyani",
        degree: "BHMS, Yoga Consultant",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Dr. Neha Mehta",
        degree: "BHMS",
        experience: "9 YRS",
        achievements: ""
      },
      {
        name: "Prof. Pramila Noronha",
        degree: "M.Sc, Microbiology",
        experience: "15 YRS",
        achievements: ""
      }
    ],
    languages: [
      {
        name: "Prof. Rohan Menon",
        degree: "M.A. (English Literature), Helicopter Pilot, M.B.A (Fin)",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Scarlett Dsouza",
        degree: "M.A. - English, Psychology Counselor",
        experience: "29 YRS",
        achievements: ""
      },
      {
        name: "Prof. Irfan Panjwani",
        degree: "M.A., B.Ed.",
        experience: "18 YRS",
        achievements: ""
      },
      {
        name: "Prof. Mayank Verma",
        degree: "MA Honors , BA in English Literature",
        experience: "13 YRS",
        achievements: ""
      },
      {
        name: "Prof. Deep Banerjee",
        degree: "B.A.",
        experience: "20 YRS",
        achievements: ""
      },
      {
        name: "Prof. Nikita Pawar",
        degree: "B.ED. , M.Com",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Mansi Shah",
        degree: "M.A - English literature, PGDFM",
        experience: "19 YRS",
        achievements: ""
      },
      {
        name: "Prof. Aditya Pawar",
        degree: "M.A. – Literature, Author for Chetna Publications",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Priyanka Lakhani",
        degree: "MSc.",
        experience: "8 YRS",
        achievements: ""
      },
      {
        name: "Prof. Hetal Jani",
        degree: "M.A., B.Ed.",
        experience: "20 YRS",
        achievements: ""
      },
      {
        name: "Prof. Disha Mehta",
        degree: "",
        experience: "",
        achievements: ""
      },
      {
        name: "Prof. Arvind Sharma",
        degree: "M.A., B.Ed.",
        experience: "25 YRS",
        achievements: ""
      },
      {
        name: "Prof. Falguni Shah",
        degree: "B. Com.",
        experience: "25 YRS",
        achievements: ""
      },
      {
        name: "Prof. Jitendra Sharma",
        degree: "M.A, D.Ed, B.Ed, PG. DSM",
        experience: "30 YRS",
        achievements: ""
      },
      {
        name: "Prof. Vaishali Ghatbandhe",
        degree: "B. Sc.",
        experience: "17 YRS",
        achievements: ""
      },
      {
        name: "Prof. Snehal Pawar",
        degree: "M.A., B.Ed.",
        experience: "11 YRS",
        achievements: ""
      },
      {
        name: "Prof. Nisha Singh",
        degree: "M.A., B.Ed.",
        experience: "17 YRS",
        achievements: ""
      },
      {
        name: "Prof. Dinesh Mishra",
        degree: "M.A., B.Ed.",
        experience: "18 YRS",
        achievements: ""
      },
      {
        name: "Prof. Reenu Updhaya",
        degree: "M.A.",
        experience: "18 YRS",
        achievements: ""
      },
      {
        name: "Prof. Ramesh Kumar",
        degree: "Ph.D. in Hindi, B.Ed",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Jyoti Yadav",
        degree: "M.A., B.Ed.",
        experience: "3 YRS",
        achievements: ""
      },
      {
        name: "Prof. Sheetal Gupta",
        degree: "M.A., B.Ed.",
        experience: "18 YRS",
        achievements: ""
      },
      {
        name: "Prof. Sangeeta Thakur",
        degree: "M.A., B.Ed.",
        experience: "9 YRS",
        achievements: ""
      },
      {
        name: "Prof. Rita Udeshi",
        degree: "B. Com.",
        experience: "13 YRS",
        achievements: ""
      },
      {
        name: "Prof. Priyanka Wakhure",
        degree: "M.A., B.Ed.",
        experience: "17 YRS",
        achievements: ""
      },
      {
        name: "Prof. Sunita Mehta",
        degree: "DBMS, B.Com",
        experience: "26 YRS",
        achievements: ""
      }
    ],
    socialScience: [
      {
        name: "Prof. Ravindra Jangid",
        degree: "MA - History, Political science, MCom",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Sudha Shetty",
        degree: "M.A. B.Ed. History & Economics",
        experience: "35 YRS",
        achievements: ""
      },
      {
        name: "Prof. Akhilesh Mishra",
        degree: "B. Sc., LLB",
        experience: "20 YRS",
        achievements: ""
      },
      {
        name: "Prof. Charmi Palan",
        degree: "BLS/LLB",
        experience: "7 YRS",
        achievements: ""
      },
      {
        name: "Prof. Aarti Anchan",
        degree: "BBI, M. Com., M.A. - Economics",
        experience: "13 YRS",
        achievements: ""
      },
      {
        name: "Prof. Rinkal Vora",
        degree: "M. Com., B.Ed. - Economics",
        experience: "13 YRS",
        achievements: ""
      },
      {
        name: "Prof. Anaya Siddique",
        degree: "B.Ed., M.A. - Geography",
        experience: "13 YRS",
        achievements: ""
      },
      {
        name: "Prof. Ami Shah",
        degree: "M. Com., B.Ed.",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Anwar Khan",
        degree: "BA, M.A, MBA",
        experience: "26 YRS",
        achievements: ""
      },
      {
        name: "Prof. Bhagyshree Bhanu",
        degree: "",
        experience: "10 YRS",
        achievements: ""
      },
      {
        name: "Prof. Vishal Khanna",
        degree: "M. Com",
        experience: "14 YRS",
        achievements: ""
      },
      {
        name: "Prof. Shubhangi Yadav",
        degree: "",
        experience: "",
        achievements: ""
      }
    ],
    commerce: [
      {
        name: "Prof. Malay Davda",
        degree: "MBA – Finance, B. Com. – Economics",
        experience: "12 YRS",
        achievements: ""
      },
      {
        name: "Prof. Syed Sadiq Mehar Zai",
        degree: "MBA, M. Com., M.A. - Economics, B. Com.",
        experience: "9 YRS",
        achievements: ""
      },
      {
        name: "Prof. Darshan Joshi",
        degree: "Pursuing PhD, PGDFM, NET, M. Com, B.Com",
        experience: "8 YRS",
        achievements: ""
      },
      {
        name: "Prof. Mitesh Wadher",
        degree: "Mcom, PGDFM,",
        experience: "19 YRS",
        achievements: ""
      }
    ]
  };

  // Animation effect for faculty sections
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      });
    }, observerOptions);
    
    document.querySelectorAll('.faculty-section').forEach(section => {
      observer.observe(section);
    });
    
    return () => {
      observer.disconnect();
    };
  }, []);

  const renderFacultySection = (title, facultyList) => {
    // Function to chunk the array into groups of 3 for desktop view
    const chunkArray = (array, size) => {
      const chunkedArr = [];
      for (let i = 0; i < array.length; i += size) {
        chunkedArr.push(array.slice(i, i + size));
      }
      return chunkedArr;
    };

    // Create columns with 3 teachers per column
    const columns = chunkArray(facultyList, 3);

    return (
      <section className="faculty-section">
        <div className="container">
          <div style={{textAlign: 'center'}}><h2 className="faculty-title">{title}</h2></div>
          <div className="faculty-grid">
            {columns.map((column, colIndex) => (
              <div key={colIndex} className="faculty-column">
                {column.map((teacher, index) => (
                  <div key={index} className="teacher-card" style={{
                    marginBottom: index < column.length - 1 ? '15px' : '0',
                    background: '#204d7d'
                  }}>
                    <div className="teacher-info">
                      <h3 style={{ color: 'white' }}>{teacher.name}</h3>
                      <p className="qualification" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>{teacher.degree}</p>
                      <p className="experience" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>Experience: {teacher.experience}</p>
                      <p className="achievements" style={{ color: 'rgba(255, 255, 255, 0.8)', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>{teacher.achievements}</p>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };

  return (
    <div className="teachers-team-page">
      <Navbar />
      <section
        className="hero-section"
        style={{
          backgroundImage: bgLoaded ? "url('/050A1647.webp')" : 'none',
          backgroundColor: '#e3eaf2',
          opacity: bgLoaded ? 1 : 0.8,
          transition: 'opacity 0.6s ease-in-out',
        }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>
            <div className="titleContainer">
              <span>OUR</span>
              <span>TEAM</span>
            </div>
          </h1>
          <p className="subtitle">Meet Our Expert Faculty</p>
        </div>
      </section>
      
      <section className="all-faculties-section" ref={facultySectionRef}>
        <div className="container">
          <h2 className="main-title">Our Expert Faculty</h2>
          
          {/* Subject Navigation Row */}
          <div className="subject-nav">
            <div className="subject-nav-container">
              <button 
                className={`subject-btn ${activeSubject === 'mathematics' ? 'active' : ''}`}
                onClick={() => handleSubjectChange('mathematics')}
              >
                Mathematics
              </button>
              <button 
                className={`subject-btn ${activeSubject === 'science' ? 'active' : ''}`}
                onClick={() => handleSubjectChange('science')}
              >
                Science
              </button>
              <button 
                className={`subject-btn ${activeSubject === 'languages' ? 'active' : ''}`}
                onClick={() => handleSubjectChange('languages')}
              >
                Languages
              </button>
              <button 
                className={`subject-btn ${activeSubject === 'socialScience' ? 'active' : ''}`}
                onClick={() => handleSubjectChange('socialScience')}
              >
                Social Science
              </button>
              <button 
                className={`subject-btn ${activeSubject === 'commerce' ? 'active' : ''}`}
                onClick={() => handleSubjectChange('commerce')}
              >
                Commerce
              </button>
            </div>
          </div>
          
          {/* Subject Details Section */}
          <div className={`subject-details ${isChanging ? 'changing' : ''}`} ref={subjectRef}>
            <div className="subject-header">
              <h3 className="subject-title">
                {activeSubject === 'mathematics' && 'Mathematics'}
                {activeSubject === 'science' && 'Science'}
                {activeSubject === 'languages' && 'Languages'}
                {activeSubject === 'socialScience' && 'Social Science'}
                {activeSubject === 'commerce' && 'Commerce'}
              </h3>
              <p className="subject-description">
                {activeSubject === 'mathematics' && 'Our mathematics faculty consists of experienced educators specializing in various branches of mathematics.'}
                {activeSubject === 'science' && 'Our science department includes experts in physics, chemistry, and biology with years of teaching experience.'}
                {activeSubject === 'languages' && 'Our language teachers are skilled in developing communication, writing, and literary analysis skills.'}
                {activeSubject === 'socialScience' && 'Our social science faculty brings history, geography, and political science to life through engaging teaching methods.'}
                {activeSubject === 'commerce' && 'Our commerce department consists of industry professionals with expertise in accounting, business studies, and economics.'}
              </p>
            </div>
            
            <div className="teacher-flow-chart">
              <div className="teacher-grid">
                {faculties[activeSubject].map((teacher, index) => (
                  <div key={index} className="teacher-card" style={{ background: '#204d7d' }}>
                    <div className="teacher-info">
                      <h3 style={{ color: 'white' }}>{teacher.name}</h3>
                      <p className="qualification" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>{teacher.degree}</p>
                      <p className="experience" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>Experience: {teacher.experience}</p>
                      <p className="achievements" style={{ color: 'rgba(255, 255, 255, 0.8)', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>{teacher.achievements}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeachersTeam;
